import { Injectable } from '@angular/core';
import { RestService } from '../http/rest';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root'
})
export class LibService {
  navigated: boolean = false;

  constructor(private _restService: RestService) {}

  public fromNow(date: any): string {
    const local = this.local(date);
    return new Date(local).toLocaleString();
  }

  local(date: any): Date {
    const stillUtc = new Date(date);
    return new Date(stillUtc.getTime() + stillUtc.getTimezoneOffset() * 60000);
  }

  public async logx(): Promise<void> {
    try {
      // Check if we're in browser environment
      if (typeof window === 'undefined') {
        console.log('Skipping fingerprint logging - not in browser environment');
        return;
      }

      // Initialize FingerprintJS
      const fp = await FingerprintJS.load();
      
      // Get the visitor identifier
      const result = await fp.get();
      
      // Get components for detailed fingerprint
      const components = result.components;
      
      const str = JSON.stringify(components);
      const log = btoa(str);
      
      this._restService.post('logx', { log: log }).subscribe({
        next: () => {
          console.log('Fingerprint logged successfully');
        },
        error: (error) => {
          console.error('Failed to log fingerprint:', error);
        }
      });
    } catch (error) {
      console.error('Error processing fingerprint:', error);
    }
  }

  gl(): { unmaskedRendererWebgl: string; unmaskedVendorWebgl: string } | null {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      document.body.appendChild(canvas);

      const webglVersion = window.location.search.indexOf('v=2') > 0 ? 2 : 1;
      const possibleNames = (webglVersion === 2) ? 
        ['webgl2', 'experimental-webgl2'] : 
        ['webgl', 'experimental-webgl'];

      const gl = canvas.getContext(possibleNames[0], { stencil: true }) as WebGLRenderingContext;
      
      if (!gl) {
        document.body.removeChild(canvas);
        return null;
      }

      const dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
      
      if (!dbgRenderInfo) {
        document.body.removeChild(canvas);
        return null;
      }

      const unmaskedRendererWebgl = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
      const unmaskedVendorWebgl = gl.getParameter(dbgRenderInfo.UNMASKED_VENDOR_WEBGL);
      
      document.body.removeChild(canvas);
      
      return { unmaskedRendererWebgl, unmaskedVendorWebgl };
    } catch (error) {
      console.error('Error getting WebGL info:', error);
      return null;
    }
  }
}
